import { isPlainObject, sum } from 'lodash-es'
import { evalData } from '@ow/utils'

const transformer = function (origin, defs = {}, rowData = {}, fields = []) {
  const { decimalDigits, code, ownViewDef = {}, operators = {}, unit } = defs
  const { payload = {} } = operators
  const finalCode = code || ownViewDef.code
  let value = origin === 0 ? origin : origin || ''
  if (finalCode) {
    const data = evalData(finalCode, {
      rowData: payload.rawRowData || rowData,
      fields,
    })

    if (isPlainObject(data)) {
      const { defaultSum, codeSlugs } = data
      value =
        sum(
          fields
            .filter((v) => codeSlugs.includes(v.slug))
            .map((v) => {
              return v.code
                ? Number(
                    evalData(v.code, {
                      rowData: payload.rawRowData || rowData,
                      fields,
                    })
                  )
                : 0
            })
        ) + defaultSum || 0
    } else {
      value = data
    }
  } else if (origin && decimalDigits) {
    if (Number(origin)) {
      value = Number(origin).toFixed(Number(decimalDigits))
    } else {
      value = origin
    }
  }

  return {
    render: 'text',
    origin,
    value: value && unit ? `${value}${unit}` : value,
    defs,
  }
}

export default transformer
